import { cn } from '~/lib/cn'

export type HeaderCardProps = {
  icon?: React.ReactNode
  description: string | React.ReactNode
  className?: string
  children?: React.ReactNode
}

export default function HeaderCard({ description, icon, children, className = '' }: HeaderCardProps) {
  return (
    <header className={cn(className, 'flex flex-col items-start gap-5 gap-y-4 self-stretch pt-2')}>
      <h2 className={`font-medium flex gap-3 w-full items-center`}>
        {icon}
        {description}
        {children}
      </h2>
    </header>
  )
}
